var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "redGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#ff0000",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#ff8080",
      stopOpacity: 1
    }
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.2099609,4H14.4101562V52.7597656H53.2099609V4Zm-29.4609375,15.0986328c0-.8632812,.703125-1.5654297,1.5664062-1.5654297h4.2441406v-4.2451172c0-.8632812,.703125-1.5664062,1.5664062-1.5664062h5.3681641c.8632812,0,1.5654297,.703125,1.5654297,1.5664062v4.2451172h4.2451172c.8632812,0,1.5664062,.7021484,1.5664062,1.5654297v5.3681641c0,.8632812-.703125,1.5664062-1.5664062,1.5664062h-4.2451172v4.2441406c0,.8632812-.7021484,1.5664062-1.5654297,1.5664062h-5.3681641c-.8632812,0-1.5664062-.703125-1.5664062-1.5664062v-4.2441406h-4.2441406c-.8632812,0-1.5664062-.703125-1.5664062-1.5664062v-5.3681641Zm17.0986328,28.0751953h-14.0751953c-.5527344,0-1-.4472656-1-1s.4472656-1,1-1h14.0751953c.5527344,0,1,.4472656,1,1s-.4472656,1-1,1Zm3.7109375-4.8886719H23.0615234c-.5527344,0-1-.4472656-1-1s.4472656-1,1-1h21.4970703c.5527344,0,1,.4472656,1,1s-.4472656,1-1,1Z",
    fill: "url(#redGradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5595703,25.5986328v4.2451172h4.5v-4.2451172c0-.8632812,.703125-1.5654297,1.5664062-1.5654297h4.2451172v-4.5h-4.2451172c-.8632812,0-1.5664062-.703125-1.5664062-1.5664062v-4.2451172h-4.5v4.2451172c0,.8632812-.7021484,1.5664062-1.5654297,1.5664062h-4.2451172v4.5h4.2451172c.8632812,0,1.5654297,.7021484,1.5654297,1.5654297Z",
    fill: "url(#redGradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6054688,53.1281128c.1151123-.0490112,.2382812-.0765381,.3574219-.1159058,.1489258-.0492554,.2929688-.1112061,.4472656-.1450195V4.1962891c-.3115234,.1289062-.5957031,.3193359-.8378906,.5654297-.5009766,.4931641-.7822266,1.1640625-.7822266,1.8486328V53.5751953c.0107422-.0075073,.0233154-.0117188,.0341797-.019104,.1019287-.0699463,.2148438-.1192627,.3217773-.1802979,.1514893-.0864258,.2990723-.1794434,.4594727-.2476807Z",
    fill: "url(#redGradient)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4082031,60H53.2060547v-5.2392578H13.4082031c-.7001953,0-1.3525391,.2714844-1.8378906,.7646484-.0100098,.0100708-.0168457,.0221558-.0266113,.0323486-.2866211,.3008423-.4887695,.6525879-.6125488,1.0289917-.0827637,.2565308-.137207,.522644-.137207,.7990112,0,1.4414062,1.1728516,2.6142578,2.6142578,2.6142578Z",
    fill: "url(#redGradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuide);
export default __webpack_public_path__ + "static/media/guide.bd76ca541658c20146daf5230fbfb3b4.svg";
export { ForwardRef as ReactComponent };